import { ACTIONS } from '@r1-frontend/shared/constants/analytics';
import { BaseButton, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { PolicyNote } from '@r1-frontend/ui-react/components/PolicyNote';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import React, { Component } from 'react';
import styled from 'styled-components';

import { POLICY_PAGE_LINK } from '~/src/constants';
import { dataLayerForCBPhonePush } from '~/src/helpers/eventsForDataLayer';

import * as ST from './styled';

const Form = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

const FormInputs = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    @media (max-width: 600px) {
        flex-direction: column;
    }

`;

const ButtonSubmit = styled(BaseButton)`
    width: 50%;
    margin-right: 10px;
    @media (max-width: 600px) {
        width: 100%;
        max-width: 100%;
        margin-right: 0;
        margin-bottom: 10px;
    }
`;

class CallBackEquipment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fio: {
                value: '',
                isValid: false,
                clearInput: () => {},
            },
            phone: {
                value: '',
                isValid: false,
                clearInput: () => {},
            },
            isValid: false,
            isSending: false,
            beenStarted: false,
            checkAgreement: true,
        };
    }

    checkValid = (name, value) => {
        const { beenStarted } = this.state;
        const { option, isPopup, isAuth, agreement } = this.props;
        this.setState({
            [name]: value,
        }, () => this.validate());

        if (!beenStarted) {
            dataLayerForCBPhonePush({
                action: isAuth ? ACTIONS.startedEquip : ACTIONS.started,
                requestId: null,
                option,
                isPopup,
                uid: isAuth ? agreement : null,
            });
            this.setState({
                beenStarted: true,
            });
        }
    };

    validate = () => {
        let isValidated = false;
        const fioValidated = this.state.fio.isValid;
        const phoneValidated = this.state.phone.isValid;
        if (fioValidated && phoneValidated) {
            isValidated = true;
        }
        this.setState({
            isValid: isValidated,
        });
    };

    onSubmit = () => {
        const { sendRequest, extParams, formRef, option } = this.props;
        const { fio, phone } = this.state;

        this.setState({ isSending: true }, async() => {
            const params = {
                phone: phone.value,
                fio: fio.value,
                option,
                isPopup: true,
                ...extParams,
            };
            // @TODO Проверить нужен ли formRef?
            await sendRequest(params, formRef);
        });
    };

    onChangeAgreementHandler = () => {
        this.setState((prev) => ({ checkAgreement: !prev.checkAgreement }));
    }

    reset = () => {
        this.state.fio.clearInput();
        this.state.phone.clearInput();
        this.setState({
            isValid: false,
            isSending: false,
        });
    };

    render() {
        const { isValid, isSending, checkAgreement } = this.state;
        const { textButton } = this.props;
        const btnText = textButton || 'Перезвоните мне';

        return (
            <Form>
                <FormInputs>
                    <ST.Name
                        name='fio'
                        placeholder='Ваше имя'
                        errorMessage='Ожидаются только буквы'
                        onChange={value => this.checkValid('fio', value)}
                        className={'ym-disable-keys'}
                    />
                    <ST.Phone
                        name='phone'
                        placeholder='Номер телефона'
                        errorMessage='Укажите корректный номер телефона'
                        onChange={value => this.checkValid('phone', value)}
                        className={'ym-disable-keys'}
                    />
                </FormInputs>
                <IndentContainer $united={[0, 0, 12, 0]}>
                    <PolicyNote
                        data-test='agreement'
                        buttonText={btnText}
                        agreeUrl={POLICY_PAGE_LINK}
                    />
                </IndentContainer>
                <ButtonSubmit
                    onClick={this.onSubmit}
                    disabled={!isValid || isSending || !checkAgreement}
                    text={btnText}
                    type={btnTypes.ACCENT}
                />
            </Form>
        );
    }
}

export default CallBackEquipment;
